/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_SeoInputs */

const cs_property_section_seo = /** @type {(inputs: Property_Section_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing a SEO`)
};

const en_property_section_seo = /** @type {(inputs: Property_Section_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing & SEO`)
};

/**
* | output |
* | --- |
* | "Marketing & SEO" |
*
* @param {Property_Section_SeoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_seo = /** @type {((inputs?: Property_Section_SeoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_SeoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_seo(inputs)
	return cs_property_section_seo(inputs)
});